import React from "react";
import PropTypes from "prop-types";
import * as CONST from "../Constants";

const propTypes = {
  hideMobileNav: PropTypes.object.isRequired,
  setHideMobileNav: PropTypes.function,
}

export default function MobileNavButton(props) {
  return (
    <>
      <div
        component="div" className='mobile-cpr-navbar'
        onClick={(e) => {
          let { innerWidth: width, innerHeight: height } = window;
          if(width < CONST.MOBILE_PIXEL_WIDTH) {
            props.setHideMobileNav(!props.hideMobileNav)
          }
        }}
      >
        {props.hideMobileNav && (
          <>
            Show Care Plan Requirements
            <i className='fa fa-caret-down mlmd mtxs float-right'/>
          </>
        )}
        {!props.hideMobileNav && (
          <>
            Hide Care Plan Requirements
            <i className='fa fa-caret-up mlmd mtxs float-right'/>
          </>
        )}
      </div>
    </>
  );
}
